import { render, staticRenderFns } from "./OrderDetailView.vue?vue&type=template&id=0d14718c&"
import script from "./OrderDetailView.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailView.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d14718c')) {
      api.createRecord('0d14718c', component.options)
    } else {
      api.reload('0d14718c', component.options)
    }
    module.hot.accept("./OrderDetailView.vue?vue&type=template&id=0d14718c&", function () {
      api.rerender('0d14718c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrderDetailView.vue"
export default component.exports